module.exports = __webpack_public_path__ + "static/media/154.694e5668.jpg";